import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { openTool } from "./Nav";
import { usePlansFrom } from "./Pricing";

export const CtaBanner = () => {
  const from = usePlansFrom();
  return (
    <section data-testid="cta-banner" className="px-3 sm:px-5 pb-20">
      <div className="relative max-w-[1440px] mx-auto rounded-3xl overflow-hidden ring-1 ring-white/10">
        <img src="/images/gen-neon-highway.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/45 to-[#050505]/80" />
        <Reveal className="relative text-center px-5 py-24 sm:py-32 lg:py-40">
          <h2 className="h-display chrome text-3xl sm:text-5xl lg:text-7xl">Your next post<br className="sm:hidden" /> starts here.</h2>
          <p className="mt-6 text-slate-200 text-base md:text-lg">
            {from != null ? `Plans from $${from}/month. ` : ""}Upload your first photo in under a minute.
          </p>
          <button data-testid="cta-banner-button" onClick={() => openTool("background")} className="btn-solid px-8 py-4 mt-9">
            Start creating <ArrowRight className="h-4 w-4" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
